import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=7fc10030&"
import script from "./Detailed.vue?vue&type=script&lang=js&"
export * from "./Detailed.vue?vue&type=script&lang=js&"
import style0 from "./Detailed.vue?vue&type=style&index=0&id=7fc10030&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports